import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import PDPGalleryRevampARButton from './PDPGalleryRevampARButton';

// shrink-0 + nowrap so a narrow viewport can't squeeze the pills into each
// other or wrap their labels onto a second line
const pillClass = 'items-center flex justify-center shrink-0 h-[30px] w-20 whitespace-nowrap rounded-full border border-solid text-xs transition-colors hover:cursor-pointer focus-visible:outline-brand';
const Divider = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-[45px] w-px bg-gray-light6" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};

// Measure / Closed-Open toggle / AR pills; each group renders independently
const PDPGalleryRevampControlsBar = t0 => {
  const $ = _c(20);
  const {
    isMeasureActive: t1,
    onToggleMeasure,
    showMeasure: t2,
    isMechanicalOpen: t3,
    toggleMechanicalOpen,
    onLaunchViewerAR: t4
  } = t0;
  const isMeasureActive = t1 === undefined ? false : t1;
  const showMeasure = t2 === undefined ? false : t2;
  const isMechanicalOpen = t3 === undefined ? null : t3;
  const onLaunchViewerAR = t4 === undefined ? null : t4;
  const showOpenCloseToggle = isMechanicalOpen != null;
  let t5;
  if ($[0] !== isMeasureActive || $[1] !== onToggleMeasure || $[2] !== showMeasure) {
    t5 = showMeasure && <button type="button" aria-pressed={isMeasureActive} onClick={onToggleMeasure} className={classNames(pillClass, {
      "bg-brand border-brand text-white": isMeasureActive,
      "bg-white border-brand text-gray-dark": !isMeasureActive
    })}>Measure</button>;
    $[0] = isMeasureActive;
    $[1] = onToggleMeasure;
    $[2] = showMeasure;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== showMeasure || $[5] !== showOpenCloseToggle) {
    t6 = showMeasure && showOpenCloseToggle && <Divider />;
    $[4] = showMeasure;
    $[5] = showOpenCloseToggle;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isMechanicalOpen || $[8] !== showOpenCloseToggle || $[9] !== toggleMechanicalOpen) {
    t7 = showOpenCloseToggle && <div className="items-center flex gap-2"><span className="text-xs text-gray-dark">Closed</span><button type="button" role="switch" aria-checked={isMechanicalOpen} onClick={toggleMechanicalOpen} className={classNames("relative h-[30px] w-[57px] rounded-full transition-colors hover:cursor-pointer focus-visible:outline-brand", {
        "bg-brand": isMechanicalOpen,
        "bg-gray-light4": !isMechanicalOpen
      })}><span className={classNames("absolute left-0 top-[3px] h-6 w-6 rounded-full bg-white shadow transition-transform", {
          "translate-x-[30px]": isMechanicalOpen,
          "translate-x-[3px]": !isMechanicalOpen
        })} /><VisuallyHidden>{isMechanicalOpen ? "Show product closed" : "Show product open"}</VisuallyHidden></button><span className="text-xs text-gray-dark">Open</span></div>;
    $[7] = isMechanicalOpen;
    $[8] = showOpenCloseToggle;
    $[9] = toggleMechanicalOpen;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = classNames(pillClass, "bg-white border-brand text-gray-dark");
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = showMeasure || showOpenCloseToggle;
  let t10;
  if ($[12] !== onLaunchViewerAR || $[13] !== t9) {
    t10 = <PDPGalleryRevampARButton className={t8} showDivider={t9} onLaunchViewerAR={onLaunchViewerAR} />;
    $[12] = onLaunchViewerAR;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t11 = <div className="flex items-center justify-center gap-4 min-h-[45px] mt-2 px-4 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" data-xc="PDPGalleryRevampControlsBar">{t5}{t6}{t7}{t10}</div>;
    $[15] = t10;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};
PDPGalleryRevampControlsBar.propTypes = {
  isMeasureActive: PropTypes.bool,
  onToggleMeasure: PropTypes.func,
  showMeasure: PropTypes.bool,
  isMechanicalOpen: PropTypes.bool,
  toggleMechanicalOpen: PropTypes.func,
  onLaunchViewerAR: PropTypes.func
};
export default PDPGalleryRevampControlsBar;